module.exports = __webpack_public_path__ + "static/media/needle.1a6d94d8.svg";